// Loaded once by the layout: recommendation HTML inserted with innerHTML cannot run inline scripts.
  /* DEF-182 — quick-add without leaving the page.
     Delegated at document level and bound once, so it covers every tile on the
     page including ones injected later by the cross-sell recommendations fetch. */
  (function () {
    if (window.__mmCardQuickAdd) return;
    window.__mmCardQuickAdd = true;

    document.addEventListener('submit', function (e) {
      var form = e.target.closest('[data-card-add-form]');
      if (!form) return;

      e.preventDefault();
      /* The PDP handler calls stopPropagation for the same reason: the global
         mmk-analytics /cart/add interceptor would otherwise post the item a
         second time. We dispatch cart:added ourselves below. */
      e.stopPropagation();

      /* S-573: one click adds once. The button is disabled below, but a submit can
         still arrive another way (Enter, a fast second tap before the repaint), so
         the form itself refuses a second post while one is in flight. */
      if (form.getAttribute('data-busy') === 'true') return;
      form.setAttribute('data-busy', 'true');
      var release = function () { form.removeAttribute('data-busy'); };

      var btn = form.querySelector('button[type="submit"]');
      var label = btn ? btn.textContent : '';
      if (btn) {
        btn.disabled = true;
        btn.textContent = btn.getAttribute('data-adding') || 'Adding…';
      }

      /* DEF-182: AbortController prevents stuck "Adding" if fetch hangs. */
      var controller = new AbortController();
      var fetchTimeout = setTimeout(function () { controller.abort(); }, 10000);
      /* Locale route (/es/cart/add.js on Spanish pages) so Shopify's messages match the page. */
      var cartRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      /* Same /cart test as mmk-analytics' cart page interceptor (covers /es/cart). */
      var onCartPage = window.location.pathname.replace(/\/$/, '').split('/').pop() === 'cart';
      fetch(cartRoot + 'cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: new FormData(form),
        signal: controller.signal
      })
        .then(function (r) {
          clearTimeout(fetchTimeout);
          if (r.ok) return r.json();
          return r.json().catch(function () { return {}; }).then(function (j) {
            var err = new Error(j.description || j.message || 'add failed');
            /* Only a 4xx with Shopify's own reason is shown; 429/5xx keep the fallback. */
            err.rejected = r.status >= 400 && r.status < 500 && r.status !== 429 && !!(j.description || j.message);
            throw err;
          });
        })
        .then(function (data) {
          try {
            var items = (data && data.items) ? data.items : (data ? [data] : []);
            // Use the real surface list id (e.g. "homepage best sellers" from the
            // section's data-item-list), resolved via the same helper the global
            // interceptor uses — not a generic 'product_card' — so the single
            // on-page add_to_cart carries the correct item_list_id. Safe fallback
            // if analytics has not loaded.
            var listId = (window.MMKAnalytics && window.MMKAnalytics.resolveItemList)
              ? (window.MMKAnalytics.resolveItemList({ fromElement: form }).item_list_id || 'product_card')
              : 'product_card';
            items.forEach(function (it) { if (it && it._mmk_list_id == null) it._mmk_list_id = listId; });
            if (items.length) {
              /* On /cart the page reloads below, which can cut off an event sent now.
                 Hand the items to the mmk-analytics bridge instead: it replays
                 cart:added once after the reload (same path the PDP add uses). */
              var queued = false;
              if (onCartPage) {
                try { sessionStorage.setItem('mmk_pending_add_to_cart', JSON.stringify(items)); queued = true; } catch (err) {}
              }
              if (!queued) {
                document.dispatchEvent(new CustomEvent('cart:added', { detail: { items: items } }));
              }
            }
          } catch (err) { /* analytics must never block the add */ }
          if (btn) btn.textContent = btn.getAttribute('data-added') || 'Added ✓';
          if (onCartPage) {
            /* S-573: on /cart ("You May Also Like") the lines, count and totals are
               server-rendered by main-cart-items, so show the new cart the way every
               other cart change on this page does (mmk-analytics ajaxAndReload, the
               Autoship toggle): reload. The button stays disabled until then. */
            setTimeout(function () { window.location.reload(); }, 400);
            return;
          }
          /* DTC-031: badge refresh handled by header.liquid fetch hook. */
          if (btn) {
            setTimeout(function () {
              btn.disabled = false;
              btn.textContent = label;
              release();
            }, 1800);
          } else {
            release();
          }
        })
        .catch(function (err) {
          clearTimeout(fetchTimeout);
          if (err && err.rejected) {
            /* Shopify refused the add (e.g. out of stock): say so on the tile. The
               button stays disabled while it shows the message, so a second click
               can't take the message as its label. */
            if (btn) {
              btn.textContent = err.message.length > 40 ? (btn.getAttribute('data-unavailable') || 'Unavailable') : err.message;
              btn.title = err.message;
              setTimeout(function () { btn.disabled = false; btn.textContent = label; btn.removeAttribute('title'); release(); }, 3000);
            } else {
              release();
            }
            return;
          }
          if (err && err.name === 'AbortError') {
            /* Timed out: the add may or may not have reached the cart. Look first;
               posting again could add it twice. The button stays disabled until the
               answer is in, so a second click can't post it again meanwhile. */
            var variantId = parseInt((form.querySelector('[name="id"]') || {}).value, 10);
            var lookCtl = new AbortController();
            var lookTimer = setTimeout(function () { lookCtl.abort(); }, 5000);
            var restore = function () { release(); if (btn) { btn.disabled = false; btn.textContent = label; } };
            setTimeout(function () {
              fetch(cartRoot + 'cart.js', { headers: { 'Accept': 'application/json' }, signal: lookCtl.signal })
                .then(function (r) { clearTimeout(lookTimer); return r.json(); })
                .then(function (cart) {
                  var landed = (cart.items || []).some(function (it) { return it.variant_id === variantId; });
                  if (landed && onCartPage) {
                    /* S-573: it did land; show it in the cart lines. */
                    if (btn) btn.textContent = btn.getAttribute('data-added') || 'Added ✓';
                    window.location.reload();
                  } else if (landed && btn) {
                    btn.textContent = btn.getAttribute('data-added') || 'Added ✓';
                    setTimeout(restore, 3000);
                  } else {
                    restore();
                  }
                })
                .catch(function () { clearTimeout(lookTimer); restore(); });
            }, 1500);
            return;
          }
          release();
          if (btn) { btn.disabled = false; btn.textContent = label; }
          /* Network failure: let the native POST through so the add still completes. */
          form.submit();
        });
    });

  /* DTC-003: same bfcache fix as main-product. Collection grids are an even
     more common path (add from grid → cart → back), so the stuck state is more
     visible here. Selects all quick-add buttons on the restored page. */
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) {
      document.querySelectorAll('.product-card__quick-add[data-add-to-cart]').forEach(function (btn) {
        btn.disabled = false;
        btn.textContent = btn.getAttribute('data-add-to-cart') || 'Add to Cart';
      });
    }
  });
  })();

